import Alert from "@/views/Alert.vue";
import AlertList from "@/views/Alert/List.vue";
import AlertEdit from "@/views/Alert/Edit.vue";
import AlertFeed from "@/views/Alert/Feed.vue";
import AlertCreate from "@/views/Alert/Create.vue";
import { FEATURE_ALERTS } from "@/constants";

const routes = [
  {
    path: "/alert",
    component: Alert,
    meta: {
      feature: FEATURE_ALERTS,
    },
    children: [
      {
        path: "",
        component: AlertList,
        name: "AlertList",
      },
      {
        path: "feed",
        component: AlertFeed,
        name: "AlertFeed",
      },
      {
        path: "create",
        component: AlertCreate,
        name: "AlertCreate",
      },
      {
        path: ":id",
        component: AlertEdit,
        name: "AlertEdit",
      },
    ],
  },
];

export default routes;
